import {rpcCall} from "../../util/rpc/rpcCalls"
import {
    EditingUserDisabled,
    NoAccessToScopeError,
    NoEditHierarchyRightError,
    NoManageUsersRightError,
    NoRightsError,
    NoSubmitTTRightError,
    NoSuchUserError,
    NotAssignedError,
    NotFoundError
} from "../errors"

export default class EditTaskService {
    getAssignedUsers(taskId) {
        return rpcCall("EditTaskService.getAssignedUsers", [taskId], this._rpcErrorHandler)
    }

    updateAssignedUsers(taskId, addedUserIds, removeUserIds) {
        return rpcCall("EditTaskService.updateAssignedUsers", [taskId, addedUserIds, removeUserIds], this._rpcErrorHandler)
    }

    updateManagers(taskId, addedUserIds, removeUserIds) {
        return rpcCall("EditTaskService.updateManagers", [taskId, addedUserIds, removeUserIds], this._rpcErrorHandler)
    }

    _rpcErrorHandler(rpcError) {
        rpcError.handleOnException('com.actimind.actitime.task.NoSuchTaskException', new NotFoundError());
        rpcError.handleOnException('com.actimind.actitime.services.EditTaskService$NoRightsToManageTaskException', new NoRightsError());
        rpcError.handleOnException('com.actimind.actitime.task.TaskIsNotAssignedToUserException', new NoRightsError());
        rpcError.handleOnException('com.actimind.actitime.services.NoRightToEditHierarchyException', new NoEditHierarchyRightError());
        rpcError.handleOnException('com.actimind.actitime.services.NoRightsToManageAccountSettings', new NoManageUsersRightError());
        rpcError.handleOnException('com.actimind.actitime.services.UserIsNotAssignedToManagerException', new NotAssignedError())
        rpcError.handleOnException('com.actimind.actitime.services.NoRightsToSubmitTTException', new NoSubmitTTRightError())
        rpcError.handleOnException('com.actimind.actitime.services.UserHasNoAccessToScopeException', new NoAccessToScopeError())
        rpcError.handleOnException('com.actimind.actitime.administration.NoSuchUserException', new NoSuchUserError())
        rpcError.handleOnException('com.actimind.actitime.administration.UserIsDisabledException', new EditingUserDisabled())
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/rpc/EditTaskService.js